import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Theme } from '@mui/material/styles'
import { makeStyles } from 'tss-react/mui'
import { Button } from '@mui/material'
import { parseDatetimeSecondString } from 'ui/utils/dateFormatUtils'
import { PreReservation } from 'types/med'
import { jstNewDate } from 'ui/utils/jstDatetime'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    boxSizing: 'border-box',
  },
}))

type PreReservationControlBarProps = {
  /** 仮予約 */
  preReservation: PreReservation
  /** キャンセルボタンクリック */
  onClickCancel: () => void
  /** SMS再送信ボタンクリック */
  onClickReSendSms: () => void
  /** 送信中 */
  sending: boolean
}
const PreReservationControlBar: React.FC<PreReservationControlBarProps> = ({
  preReservation,
  onClickCancel,
  onClickReSendSms,
  sending,
}: PreReservationControlBarProps) => {
  const { t } = useTranslation()
  const { classes } = useStyles()
  const [isExpired, setIsExpired] = useState<boolean>(false)

  // NOTE: 日時指定があれば終了時刻直前まで、なければ今回の有効期限まで。
  const jstExpiredDate = parseDatetimeSecondString(
    preReservation.access_key_expiration
  )

  useEffect(() => {
    const msToExpired = jstExpiredDate.valueOf() - jstNewDate.valueOf()
    if (0 < msToExpired) {
      setIsExpired(false)
      const maxMs = 10 * 86400 * 1000 // NOTE: setTimeoutの最大値（約25日）より小さい値
      if (maxMs < msToExpired) {
        return
      }
      const timerId = setTimeout(() => {
        setIsExpired(true)
      }, msToExpired)
      return () => {
        clearTimeout(timerId)
      }
    } else {
      setIsExpired(true)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [preReservation])

  return (
    <div className={classes.root}>
      <Button color="secondary" onClick={onClickCancel}>
        {t('仮予約の取消')}
      </Button>
      <div>
        {!isExpired && (
          <Button
            color="primary"
            variant="contained"
            onClick={onClickReSendSms}
            disabled={sending}
          >
            {t('再送信')}
          </Button>
        )}
      </div>
    </div>
  )
}

export default PreReservationControlBar
